import PropTypes from 'prop-types';

import SearchBar from '../search-bar/search-bar.component';

import MobileSearchBar from '../mobile-search-bar/mobile-search-bar.component';

import useResponsive from '../../../utils/responsive';

import 'bootstrap/dist/css/bootstrap.min.css';

// import required modules
import { Navigation, Autoplay } from 'swiper/modules';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';


import _ from 'lodash';

const CarouselSection = (props) => {

    const { images } = props;

    const { isMobile, isTablet } = useResponsive();    

    const renderCarouselItem = () => {
        return _.map(images, (image, index) => {
            const url =
                _.get(image, 'desktop_image_item.url') || _.get(image, 'desktop_image_item');
            if (!url) return null;
            const alt_text = _.get(image, 'desktop_image_alt_text');
            const has_button = _.get(image, 'desktop_image_has_button');
            const button_url = '/' + _.get(image, 'desktop_image_button_url');
            const button_image =
                _.get(image, 'desktop_button_image_item.url') === undefined
                    ? _.get(image, 'desktop_button_image_item')
                    : _.get(image, 'desktop_button_image_item.url');
            return (
                <>
                    <SwiperSlide key={index}>
                        <div className="container-fluid oct-slider-five container-fluid-adjust">
                            <img className="img-slide" src={url} alt={alt_text} />
                            {has_button && (
                                <div className="action-buttons-container-inner-two">
                                    <a href={button_url}>
                                        {' '}
                                        <img src={button_image} className="action-buttons-full" />
                                    </a>
                                </div>
                            )}
                        </div>
                    </SwiperSlide>
                </>
            );
        });
    };

    const renderCarouselItemMobile = () => {
        return _.map(images, (image, index) => {
            const mobile_url =
                _.get(image, 'mobile_image_item.url') || _.get(image, 'mobile_image_item');
            if (!mobile_url) return null;
            const mobile_alt_text = _.get(image, 'mobile_image_alt_text');
            return (
                <>
                    <SwiperSlide key={index}>
                        <div className="container-fluid oct-slider-three-mobile">
                            <div className="row">
                                <div className="col-md-12 ps-mobile">
                                    <img
                                        className="img-slide-m"
                                        src={mobile_url}
                                        alt={mobile_alt_text}
                                    />
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                </>
            );
        });
    };

    return (
        <>
            <>
                {!isMobile && (
                    <Swiper
                        modules={[Navigation, Autoplay]}
                        navigation={true}
                        spaceBetween={50}
                        slidesPerView={1}
                        loop={true}
                        autoplay={{
                            delay: 55500,
                            disableOnInteraction: false,
                        }}                        
                        className="desktop-swiper"
                    >
                        {renderCarouselItem()}{' '}
                    </Swiper>
                )}
                {isMobile && (
                    <Swiper
                        spaceBetween={50}
                        slidesPerView={1}
                        loop={true}
                        autoplay={{
                            delay: 5500,
                            disableOnInteraction: false,
                        }}
                        className="desktop-swiper"
                    >
                        {renderCarouselItemMobile()}{' '}
                    </Swiper>
                )}
            </>
            {!isMobile && (
                <div className='carousel-section-landscape-search-bar-container'>
                    <div className='carousel-section-search-bar-container'>
                        <SearchBar type="Landing" />
                    </div>
                </div>
            )}
            {isMobile && (
                <div className='carousel-section-mobile-search-bar-container'>
                    <MobileSearchBar type="Home" />
                </div>
            )}
        </>
    );
};

export default CarouselSection;

CarouselSection.propTypes = {
    images: PropTypes.array,
};

